export const drawUniqueNumbers = (min, max, quantity) => {
  const pool = []
  for (let n = min; n <= max; n++) pool.push(n)
  const result = []
  for (let i = 0; i < quantity && pool.length > 0; i++) {
    const index = Math.floor(Math.random() * pool.length)
    result.push(pool[index])
    pool.splice(index, 1)
  }
  return result.sort((a, b) => a - b)
}
